
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AboutPage = lazy(() => import('../pages/about/page'));
const VisionMissionPage = lazy(() => import('../pages/vision-mission/page'));
const DocumentsPage = lazy(() => import('../pages/documents/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const ProjectDetailPage = lazy(() => import('../pages/project-detail/page'));
const RentalPage = lazy(() => import('../pages/rental/page'));
const LandEvaluationPage = lazy(() => import('../pages/land-evaluation/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog-detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />
  },
  {
    path: '/vizyon-misyon',
    element: <VisionMissionPage />
  },
  {
    path: '/belgeler',
    element: <DocumentsPage />
  },
  {
    path: '/cozum-ortaklari',
    element: <PartnersPage />
  },
  {
    path: '/projeler',
    element: <ProjectsPage />
  },
  {
    path: '/projeler/:id',
    element: <ProjectDetailPage />
  },
  {
    path: '/kiraya-sunulan',
    element: <RentalPage />
  },
  {
    path: '/arsa-degerlendirme',
    element: <LandEvaluationPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:id',
    element: <BlogDetailPage />
  },
  {
    path: '/iletisim',
    element: <ContactPage />
  },
  {
    path: '/kvkk',
    element: <PrivacyPage />
  },
  {
    path: '/cerez-politikasi',
    element: <CookiePolicyPage />
  },
  {
    path: '/site-haritasi',
    element: <SitemapPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
